import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Pagination, Navigation, Autoplay } from "swiper";

export default class HeroOne extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="main-slider">
          <Swiper
            loop={true}
            slidesPerView={1}
            effect="fade"
            autoplay={{
              delay: 5000,
              disableOnInteraction: false
            }}
            modules={[EffectFade, Pagination, Navigation, Autoplay]}
            pagination={{
              el: "#main-slider-pagination",
              type: "bullets",
              clickable: true,
            }}
            navigation={{
              nextEl: "#main-slider__swiper-button-next",
              prevEl: "#main-slider__swiper-button-prev",
            }}
            className="swiper-container thm-swiper__slider"
          >
            <div className="swiper-wrapper">
              {/* Entertainment and Culture Slide */}
              <SwiperSlide className="swiper-slide">
                <div
                  className="image-layer"
                  style={{
                    backgroundImage:
                      "url(" +
                      publicUrl +
                      "assets/images/backgrounds/main-slider-1-1.jpg)",
                  }}
                ></div>
                <div className="main-slider-shape-1"></div>
                <div className="main-slider-shape-2"></div>
                <div className="main-slider-shape-3 zoominout"></div>
                <div className="main-slider-shape-4 zoominout-2"></div>
                <div className="main-slider-shape-5">
                  <img
                    src={
                      publicUrl + "assets/images/shapes/main-slider-shape-5.png"
                    }
                    alt=""
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-7">
                      <div className="main-slider__content">
                        <div className="category-tag">Entertainment and Culture</div>
                        <h2>
                          EXPERIENCE THE <span>EXTRAORDINARY</span>
                        </h2>
                        <p>
                          Immerse yourself in breathtaking performances, cultural landmarks, and <br />
                          unforgettable moments that define our shared human experience.
                        </p>
                        <Link
                          to={process.env.PUBLIC_URL + `/what-we-do#entertainment`}
                          className="thm-btn main-slider__btn"
                        >
                          Learn More
                        </Link>
                        <div className="main-slider-arrow">
                          <img
                            src={
                              publicUrl +
                              "assets/images/shapes/main-slider-shape-1.png"
                            }
                            className="float-bob-x"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Branding and Advertising Slide */}
              <SwiperSlide className="swiper-slide">
                <div
                  className="image-layer"
                  style={{
                    backgroundImage:
                      "url(" +
                      publicUrl +
                      "assets/images/backgrounds/main-slider-1-2.jpg)",
                  }}
                ></div>
                <div className="main-slider-shape-1"></div>
                <div className="main-slider-shape-2"></div>
                <div className="main-slider-shape-3 zoominout"></div>
                <div className="main-slider-shape-4 zoominout-2"></div>
                <div className="main-slider-shape-5">
                  <img
                    src={
                      publicUrl + "assets/images/shapes/main-slider-shape-5.png"
                    }
                    alt=""
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-7">
                      <div className="main-slider__content">
                        <div className="category-tag">Branding and Advertising</div>
                        <h2>
                          TRANSFORM <span>VISIBILITY</span> INTO <br /> POSSIBILITY
                        </h2>
                        <p>
                          Cut through the noise with strategic branding that resonates. Our data-driven approach <br />
                          combines creative excellence with market intelligence to elevate your brand.
                        </p>
                        <Link
                          to={process.env.PUBLIC_URL + `/what-we-do#branding`}
                          className="thm-btn main-slider__btn"
                        >
                          Learn More
                        </Link>
                        <div className="main-slider-arrow">
                          <img
                            src={
                              publicUrl +
                              "assets/images/shapes/main-slider-shape-1.png"
                            }
                            className="float-bob-x"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Automobile Purchase/Sales Slide */}
              <SwiperSlide className="swiper-slide">
                <div
                  className="image-layer"
                  style={{
                    backgroundImage:
                      "url(" +
                      publicUrl +
                      "assets/images/backgrounds/main-slider-1-3.jpg)",
                  }}
                ></div>
                <div className="main-slider-shape-1"></div>
                <div className="main-slider-shape-2"></div>
                <div className="main-slider-shape-3 zoominout"></div>
                <div className="main-slider-shape-4 zoominout-2"></div>
                <div className="main-slider-shape-5">
                  <img
                    src={
                      publicUrl + "assets/images/shapes/main-slider-shape-5.png"
                    }
                    alt=""
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-7">
                      <div className="main-slider__content">
                        <div className="category-tag">Automobile Purchase & Sales</div>
                        <h2>
                          DRIVE YOUR <span>AMBITIONS</span> <br /> FORWARD
                        </h2>
                        <p>
                          Find the perfect vehicle to match your lifestyle. Our transparent process puts you <br />
                          in control, offering premium selection, competitive pricing, and personalized service.
                        </p>
                        <Link
                          to={process.env.PUBLIC_URL + `/what-we-do#automobile`}
                          className="thm-btn main-slider__btn"
                        >
                          Learn More
                        </Link>
                        <div className="main-slider-arrow">
                          <img
                            src={
                              publicUrl +
                              "assets/images/shapes/main-slider-shape-1.png"
                            }
                            className="float-bob-x"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Tourist Services Slide */}
              <SwiperSlide className="swiper-slide">
                <div
                  className="image-layer"
                  style={{
                    backgroundImage:
                      "url(" +
                      publicUrl +
                      "assets/images/backgrounds/main-slider-1-4.jpg)",
                  }}
                ></div>
                <div className="main-slider-shape-1"></div>
                <div className="main-slider-shape-2"></div>
                <div className="main-slider-shape-3 zoominout"></div>
                <div className="main-slider-shape-4 zoominout-2"></div>
                <div className="main-slider-shape-5">
                  <img
                    src={
                      publicUrl + "assets/images/shapes/main-slider-shape-5.png"
                    }
                    alt=""
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-7">
                      <div className="main-slider__content">
                        <div className="category-tag">Tourist Services</div>
                        <h2>
                          DISCOVER <span>AUTHENTICALLY</span>, <br /> TRAVEL EFFORTLESSLY
                        </h2>
                        <p>
                          Explore destinations like a local while enjoying the confidence of expert guidance. <br />
                          Our curated experiences transform ordinary trips into extraordinary journeys.
                        </p>
                        <Link
                          to={process.env.PUBLIC_URL + `/what-we-do#tourism`}
                          className="thm-btn main-slider__btn"
                        >
                          Learn More
                        </Link>
                        <div className="main-slider-arrow">
                          <img
                            src={
                              publicUrl +
                              "assets/images/shapes/main-slider-shape-1.png"
                            }
                            className="float-bob-x"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </div>

            <div
              className="swiper-pagination"
              id="main-slider-pagination"
            ></div>

            <div className="main-slider__nav">
              <div
                className="swiper-button-prev"
                id="main-slider__swiper-button-next"
              >
                <i className="fa fa-long-arrow-alt-left"></i>
              </div>
              <div
                className="swiper-button-next"
                id="main-slider__swiper-button-prev"
              >
                <i className="fa fa-long-arrow-alt-right"></i>
              </div>
            </div>
          </Swiper>
        </section>

        {/* Add the CSS for the category tags */}
        <style jsx>{`
          .category-tag {
            display: inline-block;
            background-color: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(8px);
            padding: 8px 16px;
            border-radius: 50px;
            font-size: 14px;
            font-weight: 600;
            color: #ffffff;
            margin-bottom: 15px;
            text-transform: uppercase;
            letter-spacing: 1px;
            border: 1px solid rgba(255, 255, 255, 0.3);
          }
        `}</style>
      </>
    );
  }
}